import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * /json/sightings/environment/list client.
 */
export class SightingEnvironment {
    static async getList(filter) {
        const data = filter !== null && filter !== void 0 ? filter : {};
        const result = await NetFetch.postData('/json/sightings/environment/list', data);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * Historical hand-maintained sightings (sighting_old, pre-app era) as map
     * points. Same wire shape as {@link getList} but only id/lon/lat/date/
     * species + any computed astronomy/weather enrichment are populated; the
     * ocean/fishing metric columns stay unset. Shared history — not org-scoped.
     */
    static async getOldList(filter) {
        const data = filter !== null && filter !== void 0 ? filter : {};
        const result = await NetFetch.postData('/json/sightings/old-points', data);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
}
